export default (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
